<template>
    <path d="M9.74 16.99v-3.81H7.29V9.89l1.2-.03 1.2-.03.05-2.11c.05-2.09.05-2.13.31-2.66a4 4 0 0 1 .83-1.05c.8-.74 1.1-.81 3.35-.81h1.82v1.43c0 .8.05 1.52.06 1.65 0 .21-.02.21-.95.21-.55 0-1.08.04-1.18.1-.29.15-.38.63-.38 1.99v1.3h1.55c.86 0 1.56.02 1.56.04l-.23 1.1-.34 1.62-.1.54H13.6v7.62H9.74z"/>
</template>

<script>
    export default {
        name: 'facebook-full',
    }
</script>



// WEBPACK FOOTER //
// src/components/icon/FacebookFull.vue